/**
 * Canonical user-identity avatar (MS-735 AC4): a generic person glyph on an
 * accent-tinted ground, used for every user avatar across the Studio
 * (Agent Access, Studio Access, Audit Log, MCP config Users, top-bar chip).
 * Deliberately not per-user colored initials — a person is identified by
 * name/email next to the avatar, not by an invented color.
 *
 * The caller supplies the sizing/background via `className` (one of the
 * existing per-surface avatar classes, e.g. `access-avatar access-avatar-user`)
 * and an icon `size` in px matching that container.
 */
import type { CSSProperties } from 'react'

export interface AvatarProps {
  readonly className?: string
  readonly size?: number
  readonly style?: CSSProperties
}

export function Avatar({ className, size = 15, style }: AvatarProps) {
  return (
    <div className={className} style={style} aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </div>
  )
}
